(app => {

    app.service("caseModalService",
        [
            "$mdDialog", function ($mdDialog) {
                const defaults = {
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                }

                this.openAddCase = (client, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/AddCase/add-case.html",
                        controller: "addCaseController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            client
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openAddAccount = (client, clientCase, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/AddAccount/add-account.html",
                        controller: "addAccountController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            client,
                            clientCase,
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openAddFirelightAccount = (client, clientCase, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/AddFirelightAccount/add-firelight-account.html",
                        controller: "addFirelightAccountController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            client,
                            clientCase,
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openPlanningNotes = (caseId, currentUser, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/CaseNotes/planning-notes.html",
                        controller: "planningNotesController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            caseId,
                            currentUser,
                        },
                        resolve: {
                            notes: ["caseApi", function (caseApi) {
                                return caseApi.getPlanningNotes(caseId);
                            }]
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openInsuranceAccountNotes = (accountId, currentUser, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/CaseNotes/insurance-account-notes.html",
                        controller: "insuranceAccountNotesController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            accountId,
                            currentUser,
                        },
                        resolve: {
                            notes: ["insuranceAccountApi", function (insuranceAccountApi) {
                                return insuranceAccountApi.getNotes(accountId);
                            }]
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openInvestmentAccountNotes = (accountId, currentUser, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/CaseNotes/investment-account-notes.html",
                        controller: "investmentAccountNotesController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            accountId,
                            currentUser,
                        },
                        resolve: {
                            notes: ["investmentAccountApi", function (investmentAccountApi) {
                                return investmentAccountApi.getNotes(accountId);
                            }]
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openEditAccountStatus = (status, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/EditAccountStatus/edit-account-status.html",
                        controller: "editAccountStatusController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            status,
                        },
                    });

                    return $mdDialog.show(alert);
                }

                this.openEditFundingSource = (source, planTypes, taxQualifications, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/EditFundingSource/edit-funding-source.html",
                        controller: "editFundingSourceController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            source,
                            planTypes,
                            taxQualifications,
                        }
                    });

                    return $mdDialog.show(alert).then(response => {
                        return response;
                    });
                }

                this.openEditAccountRelationships = (relationships, client, account, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        templateUrl: "/App/Client/Case/CaseModalService/EditAccountRelationships/edit-account-relationships.html",
                        controller: "editAccountRelationshipsController",
                        controllerAs: "$ctrl",
                        targetEvent: $event,
                        locals: {
                            relationships,
                            client,
                            account,
                        }
                    });

                    return $mdDialog.show(alert).then(response => {
                        return response;
                    });
                }

                this.confirmCaseDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this case?",
                        textContent: 'All existing accounts belong to this case will also be deleted for all users. This action is permanent.',
                        ariaLabel: "Confirm case deletion",
                        ok: "Delete",
                        cancel: "Cancel",
                        targetEvent: $event,
                    });

                    return $mdDialog.show(confirm);
                }

                this.confirmNoteDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        multiple: true,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this note?",
                        ariaLabel: "Confirm note deletion",
                        ok: "Delete",
                        cancel: "Cancel",
                        targetEvent: $event,
                    });

                    return $mdDialog.show(confirm);
                }

                this.confirmFundingSourceDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        multiple: true,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this funding source?",
                        ariaLabel: "Confirm funding source deletion",
                        ok: "Delete",
                        cancel: "Cancel",
                        targetEvent: $event,
                    });

                    return $mdDialog.show(confirm);
                }

                this.confirmAccountDeletion = ($event) => {
                    const confirm = $mdDialog.confirm({
                        ...defaults,
                        theme: "confirmDelete",
                        title: "Are you sure you want to delete this account?",
                        ariaLabel: "Confirm account deletion",
                        ok: "Delete",
                        cancel: "Cancel",
                        targetEvent: $event,
                    });

                    return $mdDialog.show(confirm);
                }
            }
        ]);

})(window.app);